export default __webpack_public_path__ + "static/media/WilliamMazzarella.75a61f6c.png";